import { useAppSelector } from 'redux/hooks';
import { GlobalBannerError } from 'layouts/error-banner/model/error-banner';
import { useAppDispatch } from 'redux/hooks';
import { errorBannerSelector } from 'redux/slices/error-banner/error-banner.selector';
import { setErrorBanner } from 'redux/slices/error-banner/error-banner.reducer';

const useErrorBanner = (): {
    banner: GlobalBannerError | null;
    setBanner: (content: GlobalBannerError | null) => void;
    emptyBanner: () => void;
} => {
    // const [banner, setBanner] = useState<GlobalBannerError>();
    const banner = useAppSelector(errorBannerSelector);
    const dispatch = useAppDispatch();

    const setBanner = (content: GlobalBannerError | null) => {
        dispatch?.(setErrorBanner(content ?? null));
    };

    const emptyBanner = () => {
        dispatch?.(setErrorBanner(null));
    };

    return {
        banner,
        setBanner,
        emptyBanner,
    };
};

export default useErrorBanner;
